import { Preferences, PreferencesOption } from "../common/GeneralClasses";

export class PreferencesMapper {
  get(entries: PreferencesOption[]): Preferences[] {
    return entries.map((entry) => new Preferences(entry.id, entry.value));
  }
}
